module.exports = __webpack_public_path__ + "img/mcwyb.12d4b52f.png";